import "./ErrorState.css";
import { TriangleAlert } from "lucide-react";

type ErrorType = "fetch" | "save" | "empty" | "generic";

type ErrorStateProps = {
  type?: ErrorType;
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  fullPage?: boolean;
};

function ErrorState({
  type = "generic",
  title,
  message,
  actionLabel,
  onAction,
  fullPage = false,
}: ErrorStateProps) {
  const config = {
    fetch: {
      title: "Daten konnten nicht geladen werden",
      message: "Bitte überprüfe deine Verbindung oder versuche es erneut.",
      action: "Erneut laden",
    },
    save: {
      title: "Speichern fehlgeschlagen",
      message: "",
      action: "",
    },
    empty: {
      title: "Keine Daten vorhanden",
      message: "Es gibt aktuell nichts anzuzeigen.",
      action: "",
    },
    generic: {
      title: "Etwas ist schiefgelaufen",
      message: "",
      action: "Erneut versuchen",
    },
  }[type];

  const finalTitle = title ?? config.title;
  const finalMessage = message ?? config.message;
  const finalAction = actionLabel ?? config.action;
  const isSave = type === "save";

  return (
    <div className={`error-state ${fullPage ? "full-page" : ""}`}>
      <div className="error-box">
        {!isSave && <TriangleAlert size={100} className="error-icon" />}
        <h3 className="error-title">
          {finalTitle} {isSave && <TriangleAlert />}
        </h3>

        {finalMessage && <p className="error-message">{finalMessage}</p>}

        {onAction && finalAction && (
          <button className="error-button" onClick={onAction}>
            {finalAction}
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorState;
